import { render, staticRenderFns } from "./home.layout.vue?vue&type=template&id=194ed7b3&"
import script from "./home.layout.vue?vue&type=script&lang=ts&"
export * from "./home.layout.vue?vue&type=script&lang=ts&"
import style0 from "./home.layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
